export default "__VITE_ASSET__v9dg7iN9__"